import { Form } from 'react-bootstrap'
import { CustomFormControl, } from '../../../../StyledComponents';

export const EntranceDateSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formDateOfBirth">
                <Form.Label>Verfügbar ab</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Verfügbar ab eingeben"
                    type="date"
                    name="entranceDate"
                    value={values.entranceDate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.entranceDate && !errors.entranceDate}
                    isInvalid={touched.entranceDate && errors.entranceDate}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.entranceDate}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};